import React from 'react';
import { Modal, Select, Typography, Alert } from 'antd';
import { ThunderboltOutlined } from '@ant-design/icons';

const { Option } = Select;
const { Text } = Typography;

export default function PushUsersModal({
  open,
  pushTargetDevId,
  setPushTargetDevId,
  pushPersonType,
  setPushPersonType,
  pushingData,
  devices,
  onExecutePush,
  onCancel
}) {
  return (
    <Modal
      title={
        <span>
          <ThunderboltOutlined style={{ color: '#52c41a', marginRight: 8 }} />
          Push Users & Permissions to Biometric Device
        </span>
      }
      open={open}
      onOk={onExecutePush}
      onCancel={onCancel}
      confirmLoading={pushingData}
      okText="Push Data to Device"
      destroyOnClose
    >
      <div style={{ marginBottom: 16 }}>
        <Text strong style={{ display: 'block', marginBottom: 6 }}>1. Select Target Biometric Device:</Text>
        <Select
          value={pushTargetDevId}
          onChange={(val) => setPushTargetDevId(val)}
          style={{ width: '100%' }}
        >
          <Option value="ALL">📡 All Registered Devices (Broadcast to All Machines)</Option>
          {devices.map(d => (
            <Option key={d.device_id} value={String(d.device_id)}>
              🖥️ {d.device_name} (SN: {d.serial_number || 'N/A'}, IP: {d.ip_address || 'Dynamic ADMS'})
            </Option>
          ))}
        </Select>
      </div>

      <div style={{ marginBottom: 16 }}>
        <Text strong style={{ display: 'block', marginBottom: 6 }}>2. Select User Group to Push:</Text>
        <Select
          value={pushPersonType}
          onChange={(val) => setPushPersonType(val)}
          style={{ width: '100%' }}
        >
          <Option value="ALL">👥 All Mapped Users (Staff & Candidates)</Option>
          <Option value="STAFF">👔 Staff Members Only</Option>
          <Option value="CANDIDATE">🎓 Candidates Only</Option>
        </Select>
      </div>

      <Alert
        message="How Machine Sync Works"
        description="Clicking Push will queue DATA USER commands specifically for the selected machine. On its next ADMS check-in (every few seconds), the device downloads the user IDs, names, badge numbers, and admin roles directly into User Management on the machine!"
        type="info"
        showIcon
      />
    </Modal>
  );
}
